import React from 'react'
import PropTypes from 'prop-types'
import masonic from '../images/masonicon.png'

const Header = (props) => (
    <header id="header" style={props.timeout ? {display: 'none'} : {}}>
        <div className="logo">
            <img class="img-logo" src={masonic} />
        </div>
        <div className="content">
            <div className="inner">
                <h1>Reno Lodge #13 Free and Accepted Masons</h1>
                <p>Meets 1st Tuesdays at 7pm with Dinner at 6pm</p>
                <p>Dark July & August</p>
                <p>40 W 1st St</p>
                <p>Reno, NV 89501</p>
            </div>
        </div>
        <nav>
            <ul>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('intro')}}>Intro</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('work')}}>Work</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('about')}}>About</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('funerals')}}>Funerals</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('contact')}}>Contact</a></li>
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: PropTypes.func,
    timeout: PropTypes.bool
}

export default Header
